import React from 'react';
import { Modal, Button } from 'antd';
import { CheckOutlined } from '@ant-design/icons';
import './SubscriptionDetails.scss';
import { nextSubscription, nextBundle } from '../../data/data';
import { PORTAL_LINK } from '../../../../../../environments/env';

const SubscriptionDetails = ({
    visible,
    onClose,
    data,
    cancelSubscription,
    openPricingPlansModal,
    isAnnual,
    upgradeSubscription,
    upgradedModal,
    openPaymentConfirmationModal
}) => {

    const upgradeSubscriptionPackage = () => {
        if (data?.title == 'ALL3D Enterprise') {
            window.location.href = `${PORTAL_LINK}contact-us`;
        } else {
            if (upgradedModal) {
                openPaymentConfirmationModal(data?.plan_name, 'subscription');
            } else {
                upgradeSubscription(nextSubscription[data?.title].name);
            }
        }
    }

    const getButtonText = () => {
        if (data?.title == 'ALL3D Enterprise') {
            return 'Schedule a demo';
        }
        if (upgradedModal) {
            return `Switch to ${data?.package_type}`;
        }
        return `Upgrade to ${nextSubscription[data?.title].display_name}`;
    }

    return (
        <Modal
            centered
            closable
            maskClosable={false}
            visible={visible}
            onCancel={onClose}
            footer={null}
            className="subscription-details-modal"
            destroyOnClose={true}
            width={480}
        >
            <div className="order-confirmed-content">
                <div>
                    <div className="manrope f-20 w-500 black-085 lh-28 mb-8">
                        {data?.title}
                    </div>
                    {data?.description && data?.plan_type == 'subscription' &&
                        <div className="manrope f-14 w-700 black-085 lh-22 mb-24">
                            {data?.description}
                        </div>}
                    {data?.title != 'ALL3D Enterprise' ?
                        <div className="manrope f-26 w-700 black-085 lh-40" style={{ display: 'flex', alignItems: 'baseline' }}>
                            ${isAnnual ? data['priceAnnual'].toLocaleString() : data['priceMonthly'].toLocaleString()}&nbsp;<span className='manrope f-14 w-600 black-085 lh-40'>{isAnnual ? ' billed annually' : ' billed monthly'}</span>
                        </div> : <div className="manrope f-26 w-700 black-085 lh-40">
                            Let's talk
                        </div>}
                    <div className="manrope f-14 w-400 black-085 lh-28 mb-24">
                        {isAnnual ? data?.annual_images_dec : data?.images_dec}
                    </div>

                    {<div>
                        <div className="manrope f-14 w-500 lh-22 black-085 text-left" style={{ marginBottom: 16 }}>
                            Your subscription includes full access to the ALL3D platform and its AI imaging features:
                        </div>
                        {isAnnual ? data.features.map((feature, index) => (
                            <div className="text-left">
                                <CheckOutlined className="manrope f-14 lh-22 w-700 blue text-left" style={{ marginRight: 10 }} />
                                <span className="manrope f-14 w-500 lh-22 black-085 text-left">{feature}</span>
                            </div>
                        )) : data.monthly_features.map((feature, index) => (
                            <div className="text-left">
                                <CheckOutlined className="manrope f-14 lh-22 w-700 blue text-left" style={{ marginRight: 10 }} />
                                <span className="manrope f-14 w-500 lh-22 black-085 text-left">{feature}</span>
                            </div>
                        ))}
                        <div className="manrope f-14 w-700 lh-22 black-085 text-left" style={{ marginTop: 16, marginBottom: 16 }}>
                            Plus, editing tools & features:
                        </div>
                        {data.plus_features.map((feature, index) => (
                            <div className="text-left">
                                <CheckOutlined className="manrope f-14 lh-22 w-700 blue text-left" style={{ marginRight: 10 }} />
                                <span className="manrope f-14 w-500 lh-22 black-085 text-left">{feature}</span>
                            </div>
                        ))}

                        {data.credits_details &&
                            <div className="credit-system-bg" style={{ marginTop: 24, marginBottom: 24 }}>
                                <div className="manrope f-14 w-700 lh-22 black-085 text-left">
                                    <img src="/img/majesticons_coins-line.svg" className="mr-8" style={{ width: 20, height: 20 }} />
                                    Your subscription runs on credits
                                </div>
                                <div className="manrope f-14 w-500 lh-22 black-085 text-left">
                                    {isAnnual ? data.annual_credits_details : data.credits_details}
                                </div>
                            </div>}
                        {data?.title == 'ALL3D Enterprise' &&
                            <div className='mb-24'>

                            </div>}
                    </div>}
                </div>
                <div className="justify-in-center sub-actions mb-24">
                    <Button
                        className="skip-button"
                        onClick={() => openPricingPlansModal("subscriptions")}>
                        View pricing & plans
                    </Button>

                    <Button
                        className="schedule-button"
                        onClick={() => upgradeSubscriptionPackage()}>
                        {getButtonText()}
                    </Button>
                </div>
                <div onClick={cancelSubscription} className="manrope f-14 w-500 lh-22 red-d9 red-d9-hover cursor-pointer text-center">
                    Cancel subscription
                </div>
            </div>
        </Modal>
    );
};

export default SubscriptionDetails;

